import * as React from 'react'

import { StyledLogo } from './Logo.glamorous'

export const Logo: React.SFC = () => {
  /* tslint:disable max-line-length */
  return (
    <StyledLogo xmlns="http://www.w3.org/2000/svg" width="242" height="53" viewBox="0 0 242 53">
      <title>Virtu logo</title>
      <g fill="#31374F" fillRule="evenodd">
        <path d="M218.43 6v23.16c-.3 3.86.25 6.33 2.14 8.42.95 1.72 3.34 2.85 6.43 2.1 3.08.75 5.48-.38 6.43-2.1 1.9-2.04 2.45-4.5 2.14-8.42V6H242v25.26c0 4.17-1.33 7.58-4.3 10.53-2.68 2.7-6.36 4.2-10.7 4.2-4.37 0-8.04-1.5-10.7-4.2-2.97-3-4.3-6.4-4.3-10.6V6h6.43zM76.7 6l11.22 26.33L99.3 6h6.7L87.8 48 70 6m49 40h6V6h-6m29.52 18.37h2.07c6.1 0 9.2-2.2 9.2-6.56 0-4.02-3-6.1-9-6.1h-2.34v12.7zm8.1 4.58L170 46h-7.97L149.7 29.63h-1.18V46H142V6h7.64c5.7 0 9.82 1 12.36 2.98 2.8 2.2 4.2 5.13 4.2 8.76 0 2.83-.88 5.26-2.63 7.3-1.76 2.04-4.07 3.34-6.94 3.9zm36.02-16.63V46h-6.28V12.32H178V6h23v6.32M6.36 46.64h40.28V6.36H6.36v40.28zM0 53h53V0H0v53z" />
        <path d="M36 32L23.25 19 19 23.33 27.5 32" />
      </g>
    </StyledLogo>
  )
  /* tslint:enable max-line-length */
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Logo/Logo.tsx